import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import logo from '../../assets/image/logo/logo.svg';
import "./contacts.scss";
import emailjs from 'emailjs-com';

export const Contact = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = useState({ message: '', isError: false });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Проверка корректного e-mail
    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email.trim());
    };

    // Обновление полей формы
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Отправка формы
    const handleSubmit = async (e) => {
        e.preventDefault();

        // 🔹 Проверка пустых полей
        if (!formData.name.trim() || !formData.message.trim()) {
            alert(t('contact.fill_all_fields'));
            return;
        }

        // 🔹 Проверка e-mail
        if (!isValidEmail(formData.email)) {
            alert(t('contact.invalid_email'));
            return;
        }

        setIsSubmitting(true);

        try {
            await emailjs.send(
                "service_u71xsvj",  // твой Service ID
                "template_1yye20q", // твой Template ID
                {
                    name: formData.name.trim(),
                    email: formData.email.trim(),
                    message: formData.message.trim()
                },
                "o8zk2poUPdjKzckw-" // твой Public Key
            );

            setStatus({ message: t('contact.success_message'), isError: false });
            setFormData({ name: '', email: '', message: '' });

        } catch (err) {
            setStatus({ message: t('contact.request_error'), isError: true });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-container">
            <div className="contact-header">
                <h1>{t('contacts')}</h1>
            </div>

            <div className="contact-card">
                <div className="contact-content">
                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                className="form-input"
                                placeholder={t('contact.your_name')}
                                value={formData.name}
                                onChange={handleChange}
                                required
                                aria-label="Your name"
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                className="form-input"
                                placeholder={t('contact.your_email')}
                                value={formData.email}
                                onChange={handleChange}
                                required
                                aria-label="Your email"
                            />
                        </div>

                        <div className="form-group">
                            <textarea
                                name="message"
                                className="form-textarea"
                                placeholder={t('contact.your_message')}
                                value={formData.message}
                                onChange={handleChange}
                                required
                                aria-label="Your message"
                                rows="5"
                            />
                        </div>

                        <button
                            type="submit"
                            className="submit-button"
                            disabled={
                                isSubmitting ||
                                !formData.name.trim() ||
                                !formData.message.trim() ||
                                !isValidEmail(formData.email)
                            }
                        >
                            {isSubmitting ? t('contact.sending') : t('contact.send_message')}
                        </button>
                    </form>

                    <div className="contact-images">
                        <div className="image-wrapper">
                            <img
                                className="contact-logo"
                                src={logo}
                                alt={t('contact.company_logo')}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                {status.message && (
                    <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
                        {status.message}
                    </div>
                )}
            </div>
        </div>
    );
};

Contact.propTypes = {
    t: PropTypes.func.isRequired
};

export default Contact;